import { ButtonLink } from './Button';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

/**
 * 🔴 AN ADDRESS THAT LEADS NOWHERE SAYS SO, IN WORKBOOK'S OWN WORDS — design-system plan DS-6a (6.1; F33, F59).
 *
 * The back office and the portal showed the router's bare "Not Found", and the console quietly opened its Licence
 * section for any address it did not know. A mistyped or out-of-date link now gets a heading, a sentence and the way
 * home. The shell around it stays, so the menu is still there.
 */
export function NotFound({ home = '/', homeLabel = 'Go to the start' }: { home?: string; homeLabel?: string }) {
  useDocumentTitle('This page does not exist'); // DS-11b1: the tab names the page (2.4.2)
  return (
    <section className="wb-not-found">
      <h1 className="wb-not-found__title">This page does not exist</h1>
      <p className="wb-not-found__body">
        The address may be mistyped, or the page may have moved. Nothing has changed in your books.
      </p>
      <ButtonLink href={home} variant="primary">
        {homeLabel}
      </ButtonLink>
    </section>
  );
}
